import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { motion } from "framer-motion";
import Icon from "./Icon";
import { itemVariants } from "./Reveal";

export default function ServiceCard({ service }) {
  return (
    <motion.div variants={itemVariants}>
      <Link
        to={`/leistungen/${service.slug}`}
        className="group relative flex h-full flex-col overflow-hidden rounded-sm border border-light-gray bg-white p-7 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl md:p-8"
        data-testid={`service-card-${service.slug}`}
      >
        <span className="flex h-12 w-12 items-center justify-center rounded-sm bg-light-gray text-anthracite transition-colors duration-300 group-hover:bg-yellow">
          <Icon name={service.icon} className="h-6 w-6" />
        </span>
        <h3 className="mt-5 font-heading text-xl font-bold text-anthracite">{service.title}</h3>
        <p className="mt-3 flex-1 text-sm leading-relaxed text-mid-gray">{service.intro.slice(0, 120)}…</p>
        <span className="mt-5 inline-flex items-center gap-1 font-heading text-sm font-bold text-anthracite">
          Mehr erfahren
          <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </span>
        <span className="absolute inset-x-0 bottom-0 h-1 origin-left scale-x-0 bg-yellow transition-transform duration-300 group-hover:scale-x-100" />
      </Link>
    </motion.div>
  );
}
